import { Autocomplete, Box, Button, Drawer, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import '../reports.css';
import { CommonGridToolBarWithFilterText } from "../../../../Components/Common Components/CommonComponents";
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { AmountFormat, CheckAccessFunc, formatDate } from "../../../../Components/CommonFunctions/CommonFunctions";
import { DateTime } from 'luxon';

class ReferralPatientCount extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            dateIndex: 1,
            refferedReportData: [],
            FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            disDateTimePicker: null,
            filteredRefferalDetail: null,
            filteredRefferalType: null,
            refTypeData: ["Source", "Doctor", "Staff"],
            refferedType: "",
            refSourceData: [],
            refStaffData: [],
            refferalValue: "",
            total_patients : 0 ,

        }
    }

    componentDidMount() {
        this.getRefferedReportData()
        this.getReferralDctorData()
        this.getRefSourceData()
        this.getStaffRefferalData()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    onChangeHandler = (e) => {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        }, () => {
            // this.state.FilterDatas.endTime = null
            this.setState({
                FilterDatas: this.state.FilterDatas
            })
        })
    }

        getReferralDetail = () => {
        const { refferedType, refferalValue } = this.state;

        if (!refferalValue) return "";

        switch (refferedType) {
            case "Doctor":
                return refferalValue?.name || "";
            case "Source":
                return refferalValue?.source_name || "";
            case "Staff":
                return refferalValue?.id || "";
            default:
                return "";
        }
    };
    getRefferedReportData = () => {
        const { t } = this.props
        try {
            this.LoaderFunction(true)
            const refDetail = this.getReferralDetail();
            RestAPIService.getAll(Serviceurls.FO_REPORTS_REFERRAL_PATIENT_COUNT + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&ref_type=${this.state.refferedType}&ref_detail=${refDetail}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            refferedReportData: response?.data?.data ? response?.data?.data : [],
                            total_patients: response.data?.total_patients,
                        }, () => { this.LoaderFunction(false) })
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
        }
    }

    getFilteredRefferedReportData = () => {
        const { t } = this.props
        try {
            this.LoaderFunction(true)
            const refDetail = this.getReferralDetail();
            RestAPIService.getAll(Serviceurls.FO_REPORTS_REFERRAL_PATIENT_COUNT + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&ref_type=${this.state.refferedType}&ref_detail=${refDetail}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            refferedReportData: response.data.data ? response.data.data : [],
                            total_patients: response.data?.total_patients,
                            FilteredFromDate: this.state.fromDate,
                            FilteredToDate: this.state.toDate,
                        }, () => { this.LoaderFunction(false) })
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
        }
    }

    getStaffRefferalData = () => {
        const { t } = this.props
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_Config).
                then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            refStaffData: response.data.data
                        }, () => { this.LoaderFunction(false) })

                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === "fail") {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
        }
    }

    getReferralDctorData = () => {
        const { t } = this.props
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_DOCTOR).
                then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            refDoctorData: response.data.data
                        }, () => { this.LoaderFunction(false) })

                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === "fail") {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
        }
    }

    getRefSourceData = () => {
        const { t } = this.props
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_SOURCE).
                then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            refSourceData: response.data.data
                        }, () => { this.LoaderFunction(false) })

                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === "fail") {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
        }
    }
    printReports = () => {
        try {
            const refDetail = this.getReferralDetail();
            RestAPIService.getAll(Serviceurls.FO_REPORTS_REFERRAL_PATIENT_COUNT + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&patient_name=${this.state.patient_name_filter}&ref_type=${this.state.refferedType}&ref_detail=${refDetail}&export_type=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    renderFilterScreen = () => {
        const { t } = this.props
        let states = this.state
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    <Autocomplete
                        size='small'
                        sx={{ width: '20vw', ml: '1vw' }}
                        options={states.refTypeData || []}
                        getOptionLabel={(option) => option || ''}
                        value={states.refferedType || null}
                        onChange={(e, newValue) => {
                            this.setState({
                                refferedType: newValue || '',
                                refferalValue: null,
                            })
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Referred Type" />
                        )}
                    />

                    <Autocomplete
                        size='small'
                        sx={{ width: '20vw', margin: '1vw 0vw 0.5vw 1vw' }}
                        disabled={!states.refferedType}
                        options={
                            states.refferedType === "Doctor" ? (states.refDoctorData || []) :
                                states.refferedType === "Source" ? (states.refSourceData || []) :
                                    states.refferedType === "Staff" ? (states.refStaffData || []) : []
                        }
                        getOptionLabel={(option) => {
                            if (states.refferedType === "Doctor") return option?.name || ''
                            if (states.refferedType === "Source") return option?.source_name || ''
                            if (states.refferedType === "Staff") return option?.name || ''
                            return ''
                        }}
                        isOptionEqualToValue={(option, value) => {
                            if (states.refferedType === "Doctor") return option?.name === value?.name
                            if (states.refferedType === "Source") return option?.source_name === value?.source_name
                            if (states.refferedType === "Staff") return option?.id === value?.id
                            return false
                        }}
                        value={states.refferalValue || null}
                        onChange={(e, newValue) => {
                            this.setState({ refferalValue: newValue || null })
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={
                                    states.refferedType === "Source" ? "Referred Source" :
                                        states.refferedType === "Doctor" ? "Referred Doctor" :
                                            states.refferedType === "Staff" ? "Referred Staff" : "Referral Detail"
                                }
                            />
                        )}
                    />
                </Box>
                <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small" 
                        onClick={() => {
                            this.setState({
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                refferalValue: "",
                                refferedType: "",
                                filteredRefferalDetail: null,
                                filteredRefferalType: null,
                                disDateTimePicker: null,
                                FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                            },
                                () => this.getFilteredRefferedReportData()
                            )
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            this.getFilteredRefferedReportData()
                            this.setState({ FilterOpen: false })
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }
    gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.FilteredFromDate) },
            { label: "To Date", value: formatDate(this.state.FilteredToDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
            </Box>

        )
    }
    render() {
        const { t } = this.props
        this.state.refferedReportData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: "referred_type", headerName: t("Referred Type"), flex: 0.3,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.referred_type ?
                 <div>{params?.row?.referred_type}</div> : "-"}</Box>)
            },
            {
                field: "referral_details", headerName: t("Referral Details"), flex: 0.50,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.referral_details ? params?.row?.referral_details?.length > 30 ?
                    <Tooltip placement='top' title={params?.row?.referral_details} arrow><div>{params?.row?.referral_details.slice(0, 30) + "..."}</div></Tooltip> : params?.row?.referral_details : "-"}</Box>)
            },
            {
                field: "patient_count", headerName: t("Patient Count"), flex: 0.2,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_count ? params?.row?.patient_count : "0"}</Box>)
            },


        ]
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                        {AmountsCard(t("TotalPatients"), this.state.total_patients, true)}
                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className='eMed_Filter_Icon_div'>
                            <Button className='eMed_usrconf_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        </Box>
                        <Button className='eMed_usrconf_btn' onClick={() => { this.printReports() }}>
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                        </Button>
                        {/* <Button className='eMed_usrconf_btn'>
                            <img src={ImagePaths.LabUploadButton.default} alt="upload" className='eMed_action_img' />
                        </Button> */}
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.refferedReportData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={this.state.page}
                        loading={this.state.isLoader}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""

                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }
}

export default withTranslation()(ReferralPatientCount)
